var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom card-shadowless rounded-top-0"},[_c('div',{staticClass:"card-body p-0"},[_c('div',{staticClass:"row justify-content-center pb-10"},[_c('div',{staticClass:"container-fluid"},[_c('b-form',{staticClass:"form mt-0 mt-lg-10",attrs:{"id":"kt_form"},on:{"submit":_vm.onSubmit}},[_vm._t("default"),_c('FormAction',_vm._b({},'FormAction',{
              submit_button: _vm.submit_button,
              next_button: _vm.next_button,
              previous_button: _vm.previous_button,
            },false))],2)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }